export const StorefrontRoutesMap = {
    HOME: "/",
    CATALOG: "/catalog",
    PRODUCT_TEMPLATE: "/catalog/product",
    REVIEWS: "/reviews",
    CONTACTS: "/contacts",
    PRIVACY: "/privacy",
    API_REVALIDATE: "/api/revalidate",
} as const satisfies Record<string, string>
